import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import APICard from "./APICard";
import APITable from "./APITable";
import Helmet from "react-helmet";
// import {Trans} from "lingui__macro";
import {Navigation} from "./components/Navigation"
import {Route, Switch} from "react-router-dom";
import * as routes from "../../../utils/routes";
import APITemplates from "./APITemplates";

export type ModalState = "HIDE" | "CONFIRM_DISCARD" | "CONFIRM_SAVE";

interface Props {
  selectedSites: Insite.AppState["betaSelections"]["selectedSites"];
  sites: Insite.AppState["userSites"]["sites"];
}

const mapStateToProps = ({ betaSelections, userSites }: Insite.AppState) => {
  const { selectedSites } = betaSelections;
  const { sites } = userSites;
  return { selectedSites, sites };
};

export const SiteDetails: React.FC<Props> = ({ selectedSites, sites }) => {
  const [currentSite, setCurrentSite] = useState<string>(selectedSites[0]);

  useEffect(() => {
    setCurrentSite(selectedSites[0]);
  }, [selectedSites, setCurrentSite]);

  return (
    <>
      <Helmet title="Site Details" />
      <Navigation />

      {/* Routing Workflow */}
      <Switch>
        <Route
          exact
          path={routes.SITEDETAILS.Details}
          // component={APITable}
          render={(props) =>
            <APICard {...props}  sites={sites} setCurrentSite={setCurrentSite} currentSite={currentSite} />}
        />
        <Route
          exact
          path={routes.SITEDETAILS.Rules}
          render={(props) => <APITable {...props} sites={sites} setCurrentSite={setCurrentSite} currentSite={currentSite} /> }
        />
        <Route
          exact
          path={routes.SITEDETAILS.Template}
          render={(props) => <APITemplates {...props} sites={sites} setCurrentSite={setCurrentSite} currentSite={currentSite} /> }
        />
      </Switch>
    </>
  );
};

export default connect(mapStateToProps)(SiteDetails);
